import { penColorSlots, type SlotDash } from "./colorSlots";
import { setPenSettings } from "./penSession";

/**
 * Быстрая смена вида линии у пера, которое сейчас в руке.
 *
 * На уроке пунктир нужен короткими вспышками — провести вспомогательную,
 * показать невидимое ребро — и каждый раз лезть в окошко палитры долго.
 * Вид линии принадлежит точке палитры, поэтому меняем именно у неё: у
 * соседних перьев он остаётся свой.
 */

/**
 * Что перебирает клавиша. Точек здесь нет намеренно: на уроке нужны две
 * линии — обычная и вспомогательная, а третий вид только удлинял перебор.
 * В окошке палитры точки по-прежнему есть.
 */
export const PEN_DASH_ORDER: SlotDash[] = ["solid", "dashed"];

export const PEN_DASH_NAMES: Record<SlotDash, string> = {
  solid: "Сплошная",
  dashed: "Пунктир",
  dotted: "Точки",
};

/** Следующий вид линии по кругу. Точки клавишей не выбираются. */
export function nextPenDash(current: SlotDash): SlotDash {
  const i = PEN_DASH_ORDER.indexOf(current);
  // Если в руке перо «точками», клавиша возвращает к сплошной.
  if (i < 0) return PEN_DASH_ORDER[0]!;
  return PEN_DASH_ORDER[(i + 1) % PEN_DASH_ORDER.length]!;
}

/**
 * Переключить вид линии у активного пера. Возвращает название — но страница
 * его больше не всплывает: всплывающая подсказка перерисовывала доску, и
 * первый штрих после нажатия пропадал. Вид линии видно по обводке кружка
 * в палитре.
 */
export function cycleActivePenDash(): string {
  const index = penColorSlots.getActive();
  const slot = penColorSlots.get()[index];
  const next = nextPenDash(slot?.dash ?? "solid");
  penColorSlots.set(index, { dash: next });
  setPenSettings({ strokeDash: next });
  if (typeof window !== "undefined") {
    window.dispatchEvent(new Event("wb-pen-settings"));
  }
  return PEN_DASH_NAMES[next];
}
